import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-user-message-chat-input-modal',
  templateUrl: './user-message-chat-input-modal.component.html',
  styleUrls: ['./user-message-chat-input-modal.component.scss'],
})
export class UserMessageChatInputModalComponent {
  prefix = 'userMessages.';

  @ViewChild('chatInputTemplate') modalTemplate: any;
  @Output() submitEvent = new EventEmitter<string | null>();

  modalRef!: NgbModalRef;
  formGroup = new FormGroup({ message: new FormControl('') });

  constructor(public modalService: NgbModal) {}

  openModal(isMobile: boolean) {
    if (isMobile) {
      this.modalRef = this.modalService.open(this.modalTemplate, {
        windowClass: 'modal-custom-mobile',
      });
    } else {
      this.modalRef = this.modalService.open(this.modalTemplate);
    }
  }

  submit() {
    if (!this.formGroup.value.message) return;
    this.submitEvent.emit(this.formGroup.value.message);
  }
}
